import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["elementCheckbox", "elementsContainer", "contentInfo", "form"]

  connect() {
    console.log("CouncilMinutesStep4 controller connected");
    this.updateContentInfo()
    this.setupFormSubmit()
  }

  setupFormSubmit() {
    // Trouver le formulaire dans l'élément courant
    const form = this.element.querySelector('form');
    if (form) {
      console.log("Form found, adding submit listener");
      form.addEventListener('submit', (event) => {
        console.log("Form submission started");
        
        // Log tous les champs du formulaire
        const formData = new FormData(form);
        console.log("Form data:", Object.fromEntries(formData.entries()));
        
        // Log les cases à cocher cochées
        const selectedElements = this.elementCheckboxTargets
          .filter(checkbox => checkbox.checked)
          .map(checkbox => checkbox.value);
        console.log("Selected elements:", selectedElements);
        
        // Vérifier si le champ included_elements est correctement défini
        const includedElementsInputs = form.querySelectorAll('input[name="council_minute[included_elements][]"]');
        console.log("Included elements inputs:", includedElementsInputs);
      });
    } else {
      console.warn("No form found in the controller scope");
    }
  }

  updateElements(event) {
    console.log("Element checkbox changed:", event.target.value, "checked:", event.target.checked);
    this.updateContentInfo()
  }

  updateContentInfo() {
    const selectedElements = this.elementCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
    
    console.log("Updating content info. Selected elements:", selectedElements);
    
    const totalElements = this.elementCheckboxTargets.length
    const selectedCount = selectedElements.length
    
    // The step 4 page has no content summary: a missing target throws in
    // Stimulus (`?.` does not guard the getter) and broke connect().
    if (!this.hasContentInfoTarget) return

    const titleElement = this.contentInfoTarget.querySelector('#content-title')
    const descriptionElement = this.contentInfoTarget.querySelector('#content-description')
    
    if (titleElement && descriptionElement) {
      titleElement.textContent = `Configuration du contenu (${selectedCount}/${totalElements} éléments)`
      
      let description = ''
      if (selectedCount === 0) {
        description = 'Aucun élément optionnel sélectionné. Seuls les éléments obligatoires seront inclus.'
      } else if (selectedCount === totalElements) {
        description = 'Tous les éléments optionnels sont sélectionnés. Le procès-verbal sera complet.'
      } else {
        description = `${selectedCount} élément(s) optionnel(s) sélectionné(s). Le procès-verbal inclura ces éléments en plus des éléments obligatoires.`
      }
      
      descriptionElement.textContent = description
    }
  }
} 